export default __webpack_public_path__ + "static/media/mc.8111a033.svg";